import React, { useRef } from "react";
import { WidePopup, CourseCheckout, CenteredPopup } from "@obby/components";
import * as settings from "~/settings";

export function CheckoutTrialPopupView({
  course,
  isAlreadyBooked,
  locations,
  onBeforeGetPaymentIntent,
  onBookTermAccept,
  onCheckoutLogin,
  onClose,
  onConfirmFreeBooking,
  onGetPaymentIntent,
  onLoadMoreDates,
  onOpenWaitingListPopup,
  onValidateDiscount,
  session,
  ticketType,
  tutors,
  user
}) {
  const popupWrapperRef = useRef();

  function onStepChange() {
    popupWrapperRef.current.scrollTo({
      top: 0
    });
  }

  const isSoldOut =
    course.summary.hasDates && !course.summary.hasAvailableTermTrialDates;

  return (
    <WidePopup onClose={onClose} wrapperRef={popupWrapperRef}>
      <CourseCheckout
        course={course}
        courseId={course._id}
        courseThumbnail={course.galleryImagesHuge?.[0]?.url}
        courseTitle={course.title}
        courseType={course.type}
        discount={course.discount}
        locations={locations}
        isBundleEnabled={course.bundles?.length > 0}
        isOnline={course.isOnline}
        isSendingMaterial={course.requiresSendingPhysicalMaterial}
        isSoldOut={isSoldOut}
        onBeforeGetPaymentIntent={onBeforeGetPaymentIntent}
        onClose={onClose}
        onConfirmFreeBooking={onConfirmFreeBooking}
        onGetPaymentIntent={onGetPaymentIntent}
        onStepChange={onStepChange}
        onValidateDiscount={onValidateDiscount}
        onLoadDates={onLoadMoreDates}
        onLogin={onCheckoutLogin}
        openWaitingListPopup={onOpenWaitingListPopup}
        session={session}
        schoolId={course.schoolId}
        stripePublicKey={settings.stripe.publicKey}
        ticketTypes={[ticketType]}
        tutors={tutors}
        user={user}
        userInputs={course.userInputs}
      />
      {isAlreadyBooked && (
        <CenteredPopup
          title="Looks like you've booked this before"
          acceptButtonText="Book a term"
          onAccept={onBookTermAccept}
        >
          Trial bookings can only be booked once per customer. If this is a
          mistake, please{" "}
          <a className="font-weight-semi-bold" href="mailto:hello@obby.co.uk">
            email us
          </a>
          .{" "}
        </CenteredPopup>
      )}
    </WidePopup>
  );
}
